<template>
    <fade-up-animation :element="() => $refs.section">
        <section class="region-choice-section" ref="section">
            <b-container>
                <mobile-gutter>
                    <div class="header-container">
                        <h2
                            class="title"
                            v-test:title
                        >
                            {{ title }}
                        </h2>
                        <markdown-content
                            v-if="intro"
                            class="intro"
                            :content="intro"
                            v-test:intro
                        />
                    </div>
                    <div class="region-container">
                        <nuxt-link
                            v-for="region in regions"
                            :key="region.name"
                            :to="region.link"
                            class="image-container"
                            v-test:btnRegion
                        >
                            <lazy-image
                                class="content-image"
                                :src="region.icon.src"
                                :alt="region.name"
                                :width="region.icon.width"
                                :height="region.icon.height"
                                v-test:imgRegion
                            />
                        </nuxt-link>
                    </div>
                </mobile-gutter>
            </b-container>
        </section>
    </fade-up-animation>
</template>

<script>
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent';

    export default {
        name: 'region-choice-section',

        components: { MarkdownContent },

        props: {
            title: {
                type: String,
                required: true,
                default: '',
            },

            intro: {
                type: String,
                default: '',
            },

            regions: {
                type: Array,
                required: true,
                default: () => ([]),
            },
        },
    };
</script>

<style lang="scss" scoped>
    .region-choice-section {
        padding: 40px 0;
        text-align: center;
        font-size: rem(20px);
        line-height: 1.33;
    }

    .title {
        margin-bottom: 25px;
        font-weight: bold;
    }

    .intro {
        text-wrap: balance;
        max-width: 640px;
        margin-left: auto;
        margin-right: auto;
        color: #4a4a49;
    }

    .mobile-gutter {
        @include media-breakpoint-up(sm) {
            padding: 0;
        }
    }

    .region-container {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        gap: 40px;
        margin-top: 45px;

        .image-container {
            width: 80px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 0;

            .content-image {
                width: 100%;
                height: auto;
                max-height: 100%;
            }
        }
    }
</style>
